<template>
  <div>
    <div v-if="isLoading">
      <clip-loader :loading="isLoading" :size="size"></clip-loader>
      <p class="text-center">Please wait...</p>
    </div>
    <div v-else>
      <PriceSelection v-if="!subscription" :productType="productType" />
      <SubscribedAccount v-else :subscription="subscription" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import PriceSelection from './PriceSelection.vue'
import SubscribedAccount from './SubscribedAccount.vue'

export default {
  props: {
    productType: {
      type: Array
    }
  },
  components: {
    PriceSelection,
    SubscribedAccount,
    ClipLoader
  },

  data() {
    return {
      size: '20px',
      isLoading: false,
      subscription: false
    }
  },

  mounted() {
    this.fetchSubscription()
  },

  methods: {
    ...mapActions(['getSubscription']),

    async fetchSubscription() {
      try {
        this.isLoading = true
        const data = await this.getSubscription()
        if (data) {
          this.subscription = data
        }
        this.isLoading = false
      } catch (error) {
        this.subscription = false
        this.isLoading = false
      }
    }
  }
}
</script>
